import Footer from '@/components/footer'
import Header from '@/components/header'

export const DataCenter = () => {
	return (
		<div className="bg-landing-page bg-cover bg-no-repeat">
			<div className="max-w-[150rem] mx-auto">
				<Header currentPage="data-center" />
				<div className="mt-5 lg:mt-[90px] flex items-center flex-col gap-3 lg:gap-2">
					<h1 className="text-secondary text-center text-xl lg:text-5xl font-extrabold">
						Datenschutzbestimmungen
					</h1>
					<p className="text-secondary text-center text-sm lg:text-xl font-medium">
						Schutz Ihrer persönlichen Daten
					</p>
				</div>
				<div className="mt-3 lg:mt-[42px] lg:px-[42px] flex flex-col gap-[38px]">
					<div className="px-5 py-2 max-lg:mx-auto rounded-3xl w-fit bg-[#EFEFEF]">
						<p className="text-secondary text-xs lg:text-xl font-medium">
							LETZTES UPDATE: Mai 2025
						</p>
					</div>
					<p className="text-xs leading-[29px] lg:leading-[42px] lg:text-xl px-[30px] font-medium text-muted-foreground">
						Der Schutz Ihrer persönlichen Daten ist uns, der Mirzoyan GbR - handelnd unter „minmini“
						-, ein wichtiges Anliegen. Nachfolgend informieren wir Sie gemäß der
						Datenschutz-Grundverordnung (DSGVO) über die Verarbeitung Ihrer personenbezogenen Daten
						im Rahmen der Nutzung unserer Website und Dienstleistungen.
					</p>
				</div>
				<div className="mt-8 lg:px-[72px] px-5 lg:mt-[86px] flex flex-col gap-8">
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">1 . Verantwortlicher</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Verantwortlich für die Datenverarbeitung ist:
							<br />
							Mirzoyan GbR - „minmini“
							<br />
							Adresse: Kieler Straße 113, 24119 Kronshagen E-Mail: info@minmini.de
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							2 . Zwecke und Rechtsgrundlagen der Datenverarbeitung
						</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Wir verarbeiten Ihre personenbezogenen Daten zu folgenden Zwecken:
							<br />
							- Zur Durchführung und Abwicklung von Vertragsverhältnissen (Art. 6 Abs. 1 lit. b
							DSGVO)
							<br />
							- Zur Wahrung berechtigter Interessen, insbesondere zur Verbesserung unserer Services,
							zur Betrugsprävention und zur Durchsetzung rechtlicher Ansprüche (Art. 6 Abs. 1 lit. f
							DSGVO) <br />
							- Zur Erfüllung gesetzlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO) <br />- Mit
							Ihrer Einwilligung, etwa bei Newslettern (Art. 6 Abs. 1 lit. a DSGVO)
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							3 . Erhobene Datenkategorien
						</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Wir erheben und verarbeiten insbesondere folgende Daten:
							<br />
							- Kontaktdaten (Name, Anschrift, E-Mail, Telefonnummer)
							<br />
							- Zahlungsdaten (Bankverbindung)
							<br />
							- Protokolldaten (IP-Adresse, Browserinformationen, Zugriffszeiten) <br />- Inhalte
							von Nachrichten, Bewertungen oder Kontaktformularen <br />- Standortdaten bei Nutzung
							mobiler Geräte mit aktiviertem GPS
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							4 . Nutzung von Cookies und Analyse-Tools
						</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Unsere Website verwendet Cookies und Dienste wie Google Analytics zur Auswertung des
							Nutzerverhaltens. Die Nutzung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1
							lit. a DSGVO). Sie können Ihre Einstellungen jederzeit im Browser ändern oder die
							Erfassung über Opt-out-Links unterbinden.
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">5 . Empfänger der Daten</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Ihre Daten werden nur an Dritte weitergegeben, wenn dies gesetzlich erlaubt ist oder
							Sie eingewilligt haben. Empfänger können sein:
							<br />
							- IT-Dienstleister (z. B. Hosting, E-Mail)
							<br />
							- Zahlungsdienstleister
							<br />
							- Versandunternehmen
							<br />- Auftragsverarbeiter gemäß Art. 28 DSGVO
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">6 . Speicherdauer</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Wir speichern Ihre personenbezogenen Daten nur so lange, wie dies für die Erfüllung
							der genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten
							bestehen. Danach werden die Daten gelöscht oder anonymisiert.
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							7 . Ihre Rechte als betroffene Person
						</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Sie haben das Recht auf:
							<br />
							- Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten (Art. 15 DSGVO)
							<br />
							- Berichtigung unzutreffender oder unvollständiger Daten (Art. 16 DSGVO)
							<br />
							- Löschung Ihrer Daten, soweit gesetzlich zulässig (Art. 17 DSGVO)
							<br />- Einschränkung der Verarbeitung (Art. 18 DSGVO)
							<br />
							- Widerspruch gegen die Verarbeitung Ihrer Daten (Art. 21 DSGVO)
							<br />
							- Datenübertragbarkeit (Art. 20 DSGVO) <br />
							Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: info@minmini.de
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							8 . Widerruf von Einwilligungen
						</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Sie können eine erteilte Einwilligung zur Verarbeitung Ihrer personenbezogenen Daten
							jederzeit mit Wirkung für die Zukunft widerrufen. Die Rechtmäßigkeit der bis zum
							Widerruf erfolgten Verarbeitung bleibt unberührt.
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">9 . Datensicherheit</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten vor
							unbefugtem Zugriff, Verlust oder Zerstörung zu schützen. Unsere Sicherheitsmaßnahmen
							werden regelmäßig überprüft und dem Stand der Technik angepasst.
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							10 . Datenschutz bei Bewerbungen
						</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Wenn Sie sich bei uns bewerben, verarbeiten wir Ihre Daten ausschließlich zum Zweck
							der Bearbeitung Ihrer Bewerbung (Art. 6 Abs. 1 lit. b DSGVO). Nicht berücksichtigte
							Bewerbungen werden spätestens nach sechs Monaten gelöscht.
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							11 . Änderungen dieser Datenschutzerklärung
						</h2>
						<p className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium">
							Wir behalten uns vor, diese Datenschutzerklärung bei Änderungen unserer Dienste oder
							der Rechtslage anzupassen. Die jeweils aktuelle Version finden Sie auf unserer
							Website.
						</p>
					</div>
				</div>
				<div className="mt-16 lg:mt-[141px] bg-[#E6E6E6] w-full h-px" />
				<Footer />
			</div>
		</div>
	)
}
